var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46484 13.5V8.5C1.46484 6.51088 2.25502 4.60322 3.66154 3.1967C5.06807 1.79018 6.97572 1 8.96484 1C10.954 1 12.8616 1.79018 14.2681 3.1967C15.6747 4.60322 16.4648 6.51088 16.4648 8.5V13.5",
    stroke: "#536079",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4648 14.3346C16.4648 14.7767 16.2892 15.2006 15.9767 15.5131C15.6641 15.8257 15.2402 16.0013 14.7982 16.0013H13.9648C13.5228 16.0013 13.0989 15.8257 12.7863 15.5131C12.4738 15.2006 12.2982 14.7767 12.2982 14.3346V11.8346C12.2982 11.3926 12.4738 10.9687 12.7863 10.6561C13.0989 10.3436 13.5228 10.168 13.9648 10.168H16.4648V14.3346ZM1.46484 14.3346C1.46484 14.7767 1.64044 15.2006 1.953 15.5131C2.26556 15.8257 2.68948 16.0013 3.13151 16.0013H3.96484C4.40687 16.0013 4.83079 15.8257 5.14336 15.5131C5.45592 15.2006 5.63151 14.7767 5.63151 14.3346V11.8346C5.63151 11.3926 5.45592 10.9687 5.14336 10.6561C4.83079 10.3436 4.40687 10.168 3.96484 10.168H1.46484V14.3346Z",
    stroke: "#536079",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.39356cd11ff1a4a47f8dc5af74888be1.svg";
export { ForwardRef as ReactComponent };